import { Base } from '@studiometa/js-toolkit';

/**
 * ScrollingAttributes component
 */
export default class ScrollingAttributes extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'ScrollingAttributes',
    refs: ['attributes[]'],
    options: {
      card: Boolean,
    },
  };

  /**
   *
   */
  mounted() {
    this.currentIndex = 0;
    this.attributeHeight = this.$refs.attributes[0].offsetHeight;
    this.interval = setInterval(() => {
      this.nextAttribute();
    }, 5000);
  }

  /**
   * Passe à l'élément suivant avec animation
   */
  nextAttribute() {
    const prevIndex = this.currentIndex;
    this.currentIndex = (this.currentIndex + 1) % this.$refs.attributes.length;

    const nextAttribute = this.$refs.attributes[this.currentIndex];
    const prevAttribute = this.$refs.attributes[prevIndex];

    nextAttribute.style.transition = 'none';
    if (this.$options.card) {
      nextAttribute.style.transform = `translate(-50%, ${this.attributeHeight}px)`;
    } else {
      nextAttribute.style.transform = `translate(${this.attributeHeight}px)`;
    }
    nextAttribute.style.opacity = '0';

    nextAttribute.offsetHeight;

    nextAttribute.style.transition = 'opacity 0.3s, transform 0.5s';
    if (this.$options.card) {
      prevAttribute.style.transform = `translate(-50%, -${this.attributeHeight}px)`;
    } else {
      prevAttribute.style.transform = `translate(-${this.attributeHeight}px, 0)`;
    }
    prevAttribute.style.opacity = '0';

    if (this.$options.card) {
      nextAttribute.style.transform = 'translate(-50%, 0)';
    } else {
      nextAttribute.style.transform = 'translate(0, 0)';
    }
    nextAttribute.style.opacity = '1';
  }
}
